<template>
  <div>
    <div class="list-tab">
      <router-link
        to="/"
        class="tabLink"
      >
        我的目标
      </router-link>
      <span class="tabCurrent">部门考评</span>
    </div>
    <div class="container">
      <div class="sideBar">
        <a-menu
          v-model="selectedKey"
          mode="inline"
          :default-open-keys="openKeys"
          @click="handleChangeMenu"
        >
          <a-sub-menu
            v-for="(i,n) in menuList"
            :key="`sub${n}`"
          >
            <span slot="title"><span>{{ i.year }}年</span></span>
            <a-menu-item
              v-for="v in i.menuItems"
              :key="v.key"
            >
              {{ v.quarter!==0?`Q${v.quarter}季`:'年' }}度考评
            </a-menu-item>
          </a-sub-menu>
        </a-menu>
      </div>
      <div class="rightBox overTab">
        <a-tabs
          v-show="showTabs"
          type="card"
          :active-key="activeTab"
          @change="handleTabChange"
        >
          <a-tab-pane
            v-if="isSubordinate"
            key="1"
            tab="下级考评列表"
          >
            <div>
              <div
                v-if="isLoading"
                class="list-loading"
              >
                <img src="@assets/images/loading.gif">
                <div>正在加载...</div>
              </div>
              <div class="listBox">
                <a-table
                  v-if="!isLoading && okrDEList.length"
                  class="listTable"
                  :scroll="{ x: 1420 }"
                  row-key="userId"
                  :columns="columns"
                  :data-source="okrDEList"
                  :pagination="pagination"
                  @change="handleTableChange"
                >
                  <template
                    slot="username"
                    slot-scope="userId, record"
                  >
                    <div class="tdflex">
                      <span>{{ record.username }}</span>

                      <span
                        class="tdflex2"
                      >
                        <span
                          v-if="record.entryStatus === false"
                          class="tdTag1"
                        >未满3月
                        </span>
                        <span
                          v-if="record.onJob===false"
                          class="tdTag2"
                        >已离职</span>
                      </span>
                    </div>
                  </template>
                  <template
                    slot="id"
                    slot-scope="userId, record"
                  >
                    <a
                      v-if="record.id"
                      class="linkBtn"
                      @click="() => handleClickOKRView(record.id)"
                    >
                      查看
                    </a>
                    <span v-else>未制定</span>
                  </template>
                  <template
                    slot="selfEvaluation"
                    slot-scope="userId, record"
                  >
                    <span v-if="record.selfEvaluationState===1">{{ record.selfEvaluateWithScore }}</span>
                    <span
                      v-else-if="record.selfEvaluationState===0"
                      class="gray"
                    >待自评</span>
                    <span v-else-if="record.selfEvaluationState===-1">超时未自评</span>
                    <span v-else>-</span>
                  </template>
                  <template
                    slot="selfEvaluation271"
                    slot-scope="userId, record"
                  >
                    <span v-if="record.selfEvaluationState===1">{{ record.selfEvaluateOn271 }}</span>
                    <span
                      v-else-if="record.selfEvaluationState===0"
                      class="gray"
                    >待自评</span>
                    <span v-else-if="record.selfEvaluationState===-1">超时未自评</span>
                    <span v-else>-</span>
                  </template>
                  <template
                    slot="direEvaluate"
                    slot-scope="userId, record"
                  >
                    <span v-if="record.direEvaluationState===2">不考评</span>
                    <span v-else-if="record.direEvaluationState===1 || record.direEvaluationState===3">{{ record.direEvaluateWithScore }}</span>
                    <span
                      v-else-if="record.direEvaluationState===0"
                      class="gray"
                    >待考评</span>
                    <span v-else-if="record.direEvaluationState===-1">超时未考评</span>
                    <span v-else>-</span>
                  </template>
                  <template
                    slot="direEvaluate271"
                    slot-scope="userId, record"
                  >
                    <span v-if="record.direEvaluationState===2">不考评</span>
                    <div v-else-if="record.direEvaluationState===1 || record.direEvaluationState===3">
                      <div class="noWrap">
                        <span>{{ record.direEvaluateOn271 }}</span>
                        <span
                          v-if="record.entryStatus===0"
                          class="tdTag3"
                        >不计排名</span>
                      </div>
                    </div>
                    <span
                      v-else-if="record.direEvaluationState===0"
                      class="gray"
                    >待考评</span>
                    <span v-else-if="record.direEvaluationState===-1">超时未考评</span>
                    <span v-else>-</span>
                  </template>
                  <template
                    slot="interViewState"
                    slot-scope="userId, record"
                  >
                    <div v-if="!record.interViewState || record.interViewState===0">
                      -
                    </div>
                    <div
                      v-if="record.interViewState===1"
                      class="stateIng"
                    >
                      <a
                        class="linkBtn"
                        @click="() => handleEditInterView(record)"
                      >
                        待提交
                      </a>
                    </div>
                    <div
                      v-if="record.interViewState===2"
                      class="stateOk"
                    >
                      <a
                        class="linkBtn"
                        @click="() => handleEditInterView(record)"
                      >
                        修改
                      </a>
                    </div>
                    <div
                      v-if="record.interViewState===3"
                      class="stateOk"
                    >
                      已提交
                    </div>
                    <div
                      v-if="record.interViewState===4"
                      class="stateNo"
                    >
                      超时未提交
                    </div>
                  </template>
                  <template
                    slot="operation"
                    slot-scope="userId, record"
                  >
                    <div v-if="quarter!==0">
                      <div v-if="record.direEvaluationState===0">
                        <!-- 待考评  -->
                        <a
                          class="linkBtn"
                          @click="() => handleSubmitNotDE(record.id,record.username)"
                        >
                          不考评
                        </a>
                        <a-button
                          class="primaryBtn table-btn"
                          type="primary"
                          size="small"
                          @click="() => handleEditDEView(record.id)"
                        >
                          去考评
                        </a-button>
                      </div>
                      <div v-else-if="record.direEvaluationState===1">
                        <!-- 已考评  -->
                        <a
                          class="linkBtn"
                          @click="() => handleEditDEView(record.id)"
                        >
                          修改
                        </a>
                        <a
                          class="linkBtn"
                          @click="() => handleClickDEView(record.id)"
                        >
                          详情
                        </a>
                      </div>
                      <div v-else-if="record.direEvaluationState===3">
                        <!-- 已考评 但考评已关闭，不能修改  -->
                        <a
                          class="linkBtn"
                          @click="() => handleClickDEView(record.id)"
                        >
                          详情
                        </a>
                      </div>
                      <div v-else>
                        <div v-if="record.selfEvaluationState===1">
                          <!-- 有自评，查看okr自评详情页  -->
                          <a
                            class="linkBtn"
                            @click="() => handleClickSEView(record.id)"
                          >
                            详情
                          </a>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div v-if="record.yearEvalSwitchOn && !record.yearEvalDirectorStatus">
                        <!-- 待考评  -->
                        <!-- <a
                          class="linkBtn"
                          @click="() => handleSubmitNotYearDE(record)"
                        >
                          不考评
                        </a> -->
                        <a-button
                          class="primaryBtn table-btn"
                          type="primary"
                          size="small"
                          @click="() => handleEditYearDE(record)"
                        >
                          去考评
                        </a-button>
                      </div>
                      <div v-else-if="record.yearEvalSwitchOn && record.yearEvalDirectorStatus">
                        <!-- 已考评  -->
                        <a
                          class="linkBtn"
                          @click="() => handleEditYearDE(record)"
                        >
                          修改
                        </a>
                      </div>
                      <div v-else>
                        <a
                          class="linkBtn"
                          @click="() => handleClickYearDE(record)"
                        >
                          详情
                        </a>
                      </div>
                    </div>
                  </template>
                </a-table>
              </div>

              <div
                v-if="!isLoading && !okrDEList.length"
                class="list-empty"
              >
                <img src="@assets/images/empty.png">
                <div>咦 ~ 真的什么都没有耶…</div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane
            key="2"
            tab="部门考评列表"
          >
            <div class="listBox">
              <div class="listBar">
                <div>
                  <span v-if="quarter !== 0 && okrDPList.length">总计 {{ totalAll }} 人，业绩目标未制定 {{ totalNoOKR }} 人</span>
                </div>
                <a-upload
                  v-if="canUpload && quarter !== 0"
                  name="file"
                  :action="`/api/okr/file/excel/discussion/submit?year=${year}&quarter=${quarter}`"
                  :show-upload-list="false"
                  @change="uploadFile"
                >
                  <a-button
                    icon="upload"
                  >
                    上传合议结果
                  </a-button>
                </a-upload>
                <a-upload
                  v-if="canUpload && quarter === 0"
                  name="file"
                  :action="`/api/year/eval/discussion/upload?year=${year}`"
                  :show-upload-list="false"
                  @change="uploadFile"
                >
                  <a-button
                    icon="upload"
                  >
                    上传合议结果
                  </a-button>
                </a-upload>
                <!-- todo 年度上传合议待补充  -->
              </div>
              <div
                v-if="isDPLoading"
                class="list-loading"
              >
                <img src="@assets/images/loading.gif">
                <div>正在加载...</div>
              </div>
              <a-table
                v-if="!isDPLoading && okrDPList.length"
                class="listTable newSearchStyle"
                :scroll="{ x: 1700 }"
                row-key="userId"
                :columns="columnsDP"
                :data-source="okrDPList"
                :pagination="paginationDP"
                @change="handleDPChange"
              >
                <div
                  slot="filterDropdown"
                  slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
                  style="padding: 8px"
                >
                  <a-input
                    :placeholder="`输入${column.title}点击筛选`"
                    :value="selectedKeys[0]"
                    style="width: 188px; margin-bottom: 8px; display: block;"
                    @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                    @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
                  />
                  <div class="inlineFlex">
                    <a-button
                      type="link"
                      size="small"
                      @click="() => handleReset(clearFilters)"
                    >
                      重置
                    </a-button>
                    <a-button
                      type="link"
                      size="small"
                      @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
                    >
                      筛选
                    </a-button>
                  </div>
                </div>
                <a-icon
                  slot="filterIcon"
                  slot-scope="filtered"
                  type="search"
                  :style="{ color: filtered ? '#108ee9' : undefined }"
                />
                <template
                  slot="username"
                  slot-scope="userId, record"
                >
                  <div class="tdflex">
                    <span>{{ record.username }}</span>

                    <span
                      class="tdflex2"
                    >
                      <span
                        v-if="record.entryStatus === false"
                        class="tdTag1"
                      >未满3月
                      </span>
                      <span
                        v-if="record.onJob === false"
                        class="tdTag2"
                      >已离职</span>
                    </span>
                  </div>
                </template>
                <template
                  slot="okrId"
                  slot-scope="userId, record"
                >
                  <a
                    v-if="record.okrId"
                    class="linkBtn"
                    @click="() => handleClickOKRView(record.okrId)"
                  >
                    查看
                  </a>
                  <span v-else>未制定</span>
                </template>
                <template
                  slot="interViewState"
                  slot-scope="userId, record"
                >
                  <div v-if="!record.interViewState || record.interViewState===0">
                    -
                  </div>
                  <div
                    v-if="record.interViewState===1"
                    class="stateIng"
                  >
                    待提交
                  </div>
                  <div
                    v-if="record.interViewState===2 || record.interViewState===3"
                    class="stateOk"
                  >
                    已提交
                  </div>
                  <div
                    v-if="record.interViewState===4"
                    class="stateNo"
                  >
                    超时未提交
                  </div>
                </template>
                <template
                  slot="direEvaluateDetail"
                  slot-scope="userId, record"
                >
                  <div v-if="quarter!==0">
                    <div v-if="record.direEvaluationState===1 || record.direEvaluationState===3">
                      <a
                        class="linkBtn"
                        @click="() => handleClickDEView(record.okrId)"
                      >
                        详情
                      </a>
                    </div>
                    <div v-else>
                      -
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="record.yearEvalDirector">
                      <a
                        class="linkBtn"
                        @click="() => handleClickYearDE(record)"
                      >
                        详情
                      </a>
                    </div>
                    <div v-else>
                      -
                    </div>
                  </div>
                </template>
                <template
                  slot="selfEvaluation"
                  slot-scope="userId, record"
                >
                  <span v-if="record.selfEvaluationState===1">{{ record.selfEvaluateWithScore }}</span>
                  <span
                    v-else-if="record.selfEvaluationState===0"
                    class="gray"
                  >待自评</span>
                  <span v-else-if="record.selfEvaluationState===-1">超时未自评</span>
                  <span v-else>-</span>
                </template>
                <template
                  slot="selfEvaluation271"
                  slot-scope="userId, record"
                >
                  <span v-if="record.selfEvaluationState===1">{{ record.selfEvaluateOn271 }}</span>
                  <span
                    v-else-if="record.selfEvaluationState===0"
                    class="gray"
                  >待自评</span>
                  <span v-else-if="record.selfEvaluationState===-1">超时未自评</span>
                  <span v-else>-</span>
                </template>
                <template
                  slot="direEvaluate"
                  slot-scope="userId, record"
                >
                  <span v-if="record.direEvaluationState===2">不考评</span>
                  <span v-else-if="record.direEvaluationState===1 || record.direEvaluationState===3">{{ record.direEvaluateWithScore }}</span>
                  <span
                    v-else-if="record.direEvaluationState===0"
                    class="gray"
                  >待考评</span>
                  <span v-else-if="record.direEvaluationState===-1">超时未考评</span>
                  <span v-else>-</span>
                </template>
                <template
                  slot="direEvaluate271"
                  slot-scope="userId, record"
                >
                  <span v-if="record.direEvaluationState===2">不考评</span>
                  <div v-else-if="record.direEvaluationState===1 || record.direEvaluationState===3">
                    <div class="noWrap">
                      <span>{{ record.direEvaluateOn271 }}</span>
                      <span
                        v-if="record.entryStatus===0"
                        class="tdTag3"
                      >不计排名</span>
                    </div>
                  </div>
                  <span
                    v-else-if="record.direEvaluationState===0"
                    class="gray"
                  >待考评</span>
                  <span v-else-if="record.direEvaluationState===-1">超时未考评</span>
                  <span v-else>-</span>
                </template>
              </a-table>
              <div
                v-if="!isDPLoading && !okrDPList.length"
                class="list-empty"
              >
                <img src="@assets/images/empty.png">
                <div>咦 ~ 真的什么都没有耶…</div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane
            key="3"
            tab="下载考评报表"
          >
            <div class="downloadBox">
              <a-button
                v-if="dlBtnList.deptBtn"
                icon="download"
                :loading="DLLoading[2]"
                @click="handleDownload('2')"
              >
                部门合议报表下载
              </a-button>
              <a-button
                v-if="dlBtnList.buBtn"
                icon="download"
                :loading="DLLoading[1]"
                @click="handleDownload('1')"
              >
                HR合议报表下载
              </a-button>
              <a-button
                v-if="dlBtnList.groupBtn"
                icon="download"
                :loading="DLLoading[0]"
                @click="handleDownload('0')"
              >
                集团合议报表下载
              </a-button>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
    </div>
    <a-modal
      v-model="showDPModal"
      centered
      :mask-closable="false"
      :width="400"
      :footer="null"
      @cancel="hideDPModal"
    >
      <div
        class="outer"
      >
        <div v-if="stepDPModal==='loading'">
          <a-icon
            type="loading"
            class="uploading"
          />
        </div>
        <div v-if="stepDPModal==='success'">
          <img
            class="uploadIco"
            src="@assets/images/up-success.png"
          >
          <div class="uploadT6">
            上传成功！
          </div>
          <div class="sucessTips">
            {{ CountDown }}秒
          </div>
        </div>
        <div v-if="stepDPModal==='fail'">
          <img
            class="uploadIco"
            src="@assets/images/up-error.png"
          >
          <p class="uploadT6">
            {{ messageDP }}
          </p>
          <a-upload
            :action="`/api/okr/file/excel/discussion/submit?year=${year}&quarter=${quarter}`"
            :show-upload-list="false"
            @change="uploadFile"
          >
            <a-button type="primary">
              重新上传
            </a-button>
          </a-upload>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import Vue from 'vue'
import { Menu, Tabs, Table, Input, Button, message, Modal, Upload, Icon } from 'ant-design-vue'

Vue.use(Menu)
Vue.use(Tabs)
Vue.use(Table)
Vue.use(Input)
Vue.use(Button)
Vue.use(Modal)
Vue.use(Upload)
Vue.use(Icon)

const renderContent = (value) => {
  if (!value) {
    value = '-'
  }
  return value
}
const renderUpdateTime = (value) => {
  if (!value) {
    value = '-'
  } else {
    value = value.substr(5, 14)
  }
  return value
}

export default {
  name: 'DireEvaluationList',
  data() {
    return {
      year: '',
      quarter: null,
      menuList: [],
      openKeys: [],
      selectedKey: [],
      okrDEList: [],
      isLoading: true,
      pagination: {
        current: 1, // 当前页数 v-model
        defaultCurrent: 1, // 默认的当前页数
        defaultPageSize: 10, // 每页显示几条数据
        pageSize: 10,
        showQuickJumper: true, // 是否显示直通车
        showSizeChanger: true, // 显示下拉选项（每页几条）
        pageSizeOptions: ['10', '20', '50'],
        size: 'small',
      },
      isSubordinate: true,
      // 三个下载按钮loading状态的数组
      DLLoading: [false, false, false],
      isDPLoading: true,
      okrDPList: [],
      paginationDP: {
        current: 1, // 当前页数 v-model
        defaultCurrent: 1, // 默认的当前页数
        defaultPageSize: 10, // 每页显示几条数据
        pageSize: 10,
        showQuickJumper: true, // 是否显示直通车
        showSizeChanger: true, // 显示下拉选项（每页几条）
        pageSizeOptions: ['10', '20', '50'],
        size: 'small',
      },
      totalAll: 0,
      totalNoOKR: 0,
      showDPModal: false,
      stepDPModal: '',
      CountDown: '',
      messageDP: '',
      canUpload: false,
      dpBUFilter: [],
      dpBossFilter: [],
      activeTab: '1',
      dlBtnList: [],
      showTabs: false,
    }
  },
  computed: {
    columns() {
      const columns = [{
        // 姓名 所属BU 业绩目标 业绩自评 271自评 业绩上级评 271上级评 直属上级 最后一次操作 操作
        title: '姓名',
        dataIndex: 'username',
        width: 130,
        fixed: 'left',
        scopedSlots: { customRender: 'username' },
      }, {
        title: '所属BU',
        dataIndex: 'userDept',
        sorter: (a, b) => a.userDept.localeCompare(b.userDept),
      },
      // 季度考评字段开始
      {
        title: '业绩目标',
        dataIndex: 'id',
        width: 100,
        scopedSlots: { customRender: 'id' },
        sorter: (a, b) => a.id - b.id,
      }, {
        title: '业绩自评',
        dataIndex: 'selfEvaluation',
        width: 130,
        scopedSlots: { customRender: 'selfEvaluation' },
      }, {
        title: '自评',
        dataIndex: 'selfEvaluation271',
        width: 130,
        scopedSlots: { customRender: 'selfEvaluation271' },
      }, {
        title: '业绩上级评',
        dataIndex: 'direEvaluate',
        width: 130,
        scopedSlots: { customRender: 'direEvaluate' },
      }, {
        title: '上级评',
        dataIndex: 'direEvaluate271',
        width: 130,
        scopedSlots: { customRender: 'direEvaluate271' },
      },
      // 季度考评字段结束，年度考评字段开始
      {
        title: 'Q1',
        dataIndex: 'quarterEvalOne',
        width: 50,
        customRender: renderContent,
      },
      {
        title: 'Q2',
        dataIndex: 'quarterEvalTwo',
        width: 50,
        customRender: renderContent,
      },
      {
        title: 'Q3',
        dataIndex: 'quarterEvalThree',
        width: 50,
        customRender: renderContent,
      },
      {
        title: 'Q4',
        dataIndex: 'quarterEvalFour',
        width: 50,
        customRender: renderContent,
      }, {
        title: '年度自评',
        dataIndex: 'yearEvalSelf',
        width: 130,
        customRender: renderContent,
      }, {
        title: '年度上级评',
        dataIndex: 'yearEvalDirector',
        width: 130,
        customRender: renderContent,
      },
      // 年度考评字段结束
      {
        title: '直属上级',
        dataIndex: this.quarter === 0 ? 'directorUser' : 'direName',
        customRender: renderContent,
      }, {
        title: '最后一次操作时间',
        dataIndex: this.quarter === 0 ? 'lastUpdateDate' : 'updateTime',
        customRender: renderUpdateTime,
      },
      {
        title: this.quarter === 0 ? '年度终评' : '终评',
        dataIndex: this.quarter === 0 ? 'yearEvalEnd' : 'endEvaluation',
        customRender: renderContent,
      }, {
        title: '面谈纪要',
        dataIndex: 'interViewState',
        width: 130,
        fixed: 'right',
        scopedSlots: { customRender: 'interViewState' },
      }, {
        title: '操作',
        dataIndex: 'operation',
        width: 142,
        fixed: 'right',
        className: 'column-operate',
        scopedSlots: { customRender: 'operation' },
      }]
      if (this.quarter === 0) {
        columns.splice(
          columns.findIndex((c) => c.dataIndex === 'id'),
          5,
        )
      } else {
        columns.splice(
          columns.findIndex((c) => c.dataIndex === 'quarterEvalOne'),
          6,
        )
      }
      return columns
    },
    columnsDP() {
      let { dpBUFilter, dpBossFilter } = this
      dpBUFilter = dpBUFilter || {}
      dpBossFilter = dpBossFilter || {}
      const columnsDP = [
        // 姓名 所属BU 直属上级  业绩目标 业绩自评 271自评 业绩上级评 271上级评 271三级部门评 271二级部门评 271BU评 271集团评
        { title: '姓名',
          dataIndex: 'username',
          width: 130,
          fixed: 'left',
          scopedSlots: { filterDropdown: 'filterDropdown', filterIcon: 'filterIcon', customRender: 'username' },
          onFilter: (value, record) => record.username.toString().toLowerCase().includes(value.toLowerCase()),
        }, {
          title: '所属BU',
          width: 130,
          dataIndex: this.quarter === 0 ? 'bu' : 'userDept',
          customRender: renderContent,
          fixed: 'left',
          filters: dpBUFilter,
          onFilter: (value, record) => {
            let res
            if (this.quarter === 0) {
              res = record.bu && record.bu.indexOf(value) === 0
            } else {
              res = record.userDept && record.userDept.indexOf(value) === 0
            }
            return res
          },

        }, {
          title: '直属上级',
          dataIndex: this.quarter === 0 ? 'directUser' : 'bossName',
          width: 100,
          customRender: renderContent,
          filters: dpBossFilter,
          onFilter: (value, record) => {
            // eslint-disable-next-line
            // console.log(record, record.bossName)
            // bossName为null时，indexOf会报错
            let res
            if (this.quarter === 0) {
              res = record.directUser && record.directUser.indexOf(value) === 0
            } else {
              res = record.bossName && record.bossName.indexOf(value) === 0
            }
            return res
          },
        },
        { // 季度考评字段
          title: '业绩目标',
          dataIndex: 'okrId',
          width: 100,
          scopedSlots: { customRender: 'okrId' },
          sorter: (a, b) => a.okrId - b.okrId,
        }, {
          title: '面谈纪要',
          dataIndex: 'interViewState',
          width: 130,
          scopedSlots: { customRender: 'interViewState' },
          sorter: (a, b) => a.interViewState - b.interViewState,
        }, {
          title: '考评详情',
          dataIndex: 'direEvaluateDetail',
          scopedSlots: { customRender: 'direEvaluateDetail' },
        }, {// 季度考评字段
          title: '业绩自评',
          dataIndex: 'selfEvaluation',
          width: 130,
          scopedSlots: { customRender: 'selfEvaluation' },
        },
        {// 季度考评字段
          title: '自评',
          dataIndex: 'selfEvaluation271',
          width: 130,
          scopedSlots: { customRender: 'selfEvaluation271' },
        }, {// 季度考评字段
          title: '业绩上级评',
          dataIndex: 'direEvaluate',
          width: 130,
          scopedSlots: { customRender: 'direEvaluate' },
        }, {// 季度考评字段
          title: '上级评',
          dataIndex: 'direEvaluate271',
          width: 130,
          scopedSlots: { customRender: 'direEvaluate271' },
        },
        {// 年度考评字段
          title: 'Q1',
          dataIndex: 'quarterEvalOne',
          width: 50,
          customRender: renderContent,
        },
        {// 年度考评字段
          title: 'Q2',
          dataIndex: 'quarterEvalTwo',
          width: 50,
          customRender: renderContent,
        },
        {// 年度考评字段
          title: 'Q3',
          dataIndex: 'quarterEvalThree',
          width: 50,
          customRender: renderContent,
        },
        {// 年度考评字段
          title: 'Q4',
          dataIndex: 'quarterEvalFour',
          width: 50,
          customRender: renderContent,
        }, {// 年度考评字段
          title: '年度自评',
          dataIndex: 'yearEvalSelf',
          width: 130,
          customRender: renderContent,
        }, {// 年度考评字段
          title: '年度上级评',
          dataIndex: 'yearEvalDirector',
          width: 130,
          customRender: renderContent,
        },
        {
          title: this.quarter === 0 ? '年度三级部门评' : '三级部门评',
          dataIndex: this.quarter === 0 ? 'yearEvalThree' : 'level3EvaluateOn271',
          customRender: renderContent,
        }, {
          title: this.quarter === 0 ? '年度二级部门评' : '二级部门评',
          dataIndex: this.quarter === 0 ? 'yearEvalSecond' : 'level2EvaluateOn271',
          customRender: renderContent,
        }, {
          title: this.quarter === 0 ? '年度BU评' : 'BU评',
          dataIndex: this.quarter === 0 ? 'yearEvalBu' : 'buEvaluateOn271',
          customRender: renderContent,
        }, {
          title: this.quarter === 0 ? '年度集团评' : '集团评',
          dataIndex: this.quarter === 0 ? 'yearEvalGroup' : 'groupEvaluateOn271',
          customRender: renderContent,
        }, {
          title: this.quarter === 0 ? '年度终评' : '终评',
          dataIndex: this.quarter === 0 ? 'yearEvalEnd' : 'endEvaluation',
          customRender: renderContent,
        }]
      if (this.quarter === 0) {
        columnsDP.splice(
          columnsDP.findIndex((c) => c.dataIndex === 'okrId'),
          1,
        )
        columnsDP.splice(
          columnsDP.findIndex((c) => c.dataIndex === 'selfEvaluation'),
          4,
        )
      } else {
        columnsDP.splice(
          columnsDP.findIndex((c) => c.dataIndex === 'quarterEvalOne'),
          6,
        )
      }
      return columnsDP
    },
  },
  watch: {
    quarter(val) {
      if (val) {
        this.getDataofTab()
      }
    },
    activeTab(val) {
      if (val) {
        this.getDataofTab()
      }
    },
  },
  created() {
    this.year = Number(this.$route.query.year)
    this.quarter = Number(this.$route.query.quarter)
    // 获取menu数据并渲染menu
    this.getMenuListData()
  },
  methods: {
    // 渲染年和季度的Menu，获取下级考评列表数据，若没有数据则不显示该tab
    async getMenuListData() {
      const { beginQuarter, endQuarter } = await this.$api.okr.getTimeRange()
      // eslint-disable-next-line
      console.log('begin',typeof(beginQuarter.year), typeof(beginQuarter.quarter))
      // eslint-disable-next-line
      console.log('end',endQuarter.year, endQuarter.quarter)
      const startY = Number(beginQuarter.year)
      const startQ = beginQuarter.quarter
      const endY = Number(endQuarter.year)
      const endQ = endQuarter.quarter
      const currentY = Number(this.$route.query.year)
      const currentQ = Number(this.$route.query.quarter)
      let k = 0

      for (let i = endY; i >= startY; i--) {
        const tempQ = []
        let tmpEndQ = 4
        let tmpStartQ = 1

        if (i === endY) {
          tmpEndQ = endQ
        }
        if (i === startY) {
          tmpStartQ = startQ
        }
        for (let r = tmpEndQ; r >= tmpStartQ; r--) {
          if (r === 4) {
            tempQ.push({ quarter: 0, year: i, key: k })
            k = k + 1
          }
          tempQ.push({ quarter: r, year: i, key: k })
          if (i === currentY && r === currentQ) {
            this.selectedKey.push(k)
          }
          k = k + 1
        }
        this.menuList.push({
          year: i,
          menuItems: tempQ,
        })
      }
      if (currentQ === 0) {
        const arr = []
        this.menuList.forEach(y => {
          if (y.year === currentY) {
            arr.push(y.menuItems[0].key)
          }
        })
        this.selectedKey = arr
        // 年度考评主动调方法
        this.fetchDEList()
      }
      for (let i = 0; i < (this.menuList.length - 1); i++) {
        this.openKeys.push(`sub${i}`)
      }
    },
    // 点击Menu切换页面
    handleChangeMenu(e) {
      this.menuList.forEach(y => {
        y.menuItems.forEach(i => {
          if (i.key === e.key) {
            this.quarter = i.quarter
            this.year = y.year
          }
        })
      })
      this.$router.push({
        path: 'direEvaluationList',
        query: {
          year: this.year,
          quarter: this.quarter,
        },
      })
      // 重置上传按钮显示权限，列表刷新时重新获取
      this.canUpload = false
      // 重新获取下级考评列表数据，若无数据，则tab消失
      this.fetchDEList()
      this.getDataofTab()
    },
    // 获取考评数据列表的数据
    //   okrDEList 数据结构：
    //   maxPageIndex  //总页数
    //   okrEvaluationList:[{ //考评列表
    //     direEvaluateOn271  271主管评：-2 "-"、-1超时未考评、0待考评、1有内容、2不考评
    //     direEvaluateWithScore  主管评总分
    //     direEvaluationState   考评状态
    //     direName   考评主管姓名
    //     entryStatus    距考评时的入职状态：false三个月内、true正式员工
    //     onJob  是否在职：false不在职、true在职
    //     id   对应okr的id
    //     selfEvaluateOn271   271自评
    //     selfEvaluateWithScore  自评总分
    //     selfEvaluationState  自评状态：-2"-"、-1超时未自评、0待自评、1有内容
    //     updateTime  考评时间
    //     userDept  所在部门
    //     userId  员工标识
    //     userIdOfDire    考评人userId
    //     username  姓名}]
    async fetchDEList() {
      try {
        this.isLoading = true

        if (this.quarter !== 0) {
          const { maxPageIndex, okrEvaluationList } = await this.$api.okr.getDEList({
            year: this.year,
            quarter: this.quarter,
          })
          // eslint-disable-next-line
          console.log(maxPageIndex, okrEvaluationList)
          this.$set(this, 'okrDEList', okrEvaluationList)

          const pagination = { ...this.pagination }
          pagination.current = 1
          pagination.total = maxPageIndex
          this.pagination = pagination
          // 切换menu时 重新获取下级，若有数据，则显示下级考评tab
        } else {
          const result = await this.$api.okr.getDEListInYear({ year: this.year })
          // eslint-disable-next-line
          console.log('result', result)
          this.$set(this, 'okrDEList', result)
          const pagination = { ...this.pagination }
          pagination.current = 1
          pagination.total = result.length
          this.pagination = pagination
        }
        if (!this.isSubordinate) {
          this.isSubordinate = true
        }
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        // 若报错匹配 illegalCall ，则认为没有权限查看下级考评列表的信息
        if (error.code === 'illegalCall') {
          this.isSubordinate = false
          this.activeTab = '2'
        } else {
          message.error(msg)
        }
      } finally {
        this.isLoading = false
        this.showTabs = true
      }
    },
    // 下级考评列表点击换页
    handleTableChange(pagination) {
      const pager = { ...this.pagination }
      pager.current = pagination.current
      pager.pageSize = pagination.pageSize
      this.pagination = pager
    },
    // 点击不考评按钮 调用提交主管评按钮
    handleSubmitNotDE(id, username) {
      // eslint-disable-next-line
      console.log('id', id)
      if (!id) {
        return
      }
      Modal.confirm({
        title: `是否确认 “不考评” ${username}？`,
        content: '“不考评” 后将无法修改。',
        icon: 'exclamation-circle',
        okText: '不考评',
        cancelText: '取消',
        onOk: async () => {
          try {
            // 请求接口并提交不考评的数据
            await this.$api.okr.submitDE({
              direEvaluateOn271: '-1',
              highlightAndWeakness2: '',
              krEvaluationList: null,
              id,
            })
            // 刷新列表数据
            this.fetchDEList()
          } catch (error) {
            const msg = error.errorMessage || error.message || '网络错误'
            message.error(msg)
          }
        },
      })
    },
    // 点击按钮编辑考评
    handleEditDEView(id) {
      if (!id) {
        return
      }

      const { href } = this.$router.resolve({
        name: 'EditDireEvaluation',
        params: { okrId: id },
      })
      window.open(href, '_blank')
    },
    // 点击按钮查看考评详情
    handleClickDEView(id) {
      if (!id) {
        return
      }

      const { href } = this.$router.resolve({
        name: 'DireEvaluationDetail',
        params: { okrId: id },
      })
      window.open(href, '_blank')
    },
    // 有自评，不考评/超时未考评，点击按钮查看自评详情
    handleClickSEView(id) {
      if (!id) {
        return
      }

      const { href } = this.$router.resolve({
        name: 'SelfEvaluationDetail',
        params: { okrId: id },
      })
      window.open(href, '_blank')
    },
    // 点击下载绩效表按钮
    async handleDownload(value) {
      // eslint-disable-next-line
        console.log('点了按钮', value)
      let timeout = null
      clearTimeout(timeout)
      this.DLLoading[value] = true
      // 强制视图重新渲染，更新按钮loading状态
      this.$forceUpdate()
      timeout = setTimeout(() => {
        this.DLLoading[value] = false
        // 强制视图重新渲染，更新按钮loading状态
        this.$forceUpdate()
      }, 3000)
      if (this.quarter !== 0) {
        try {
          const href = `/api/okr/file/excel/discussion/download?year=${this.year}&quarter=${this.quarter}&type=${value}`
          window.open(href, '_blank')
        } catch (error) {
          const msg = error.errorMessage || error.message || '网络错误'
          message.error(msg)
        }
      } else {
        try {
          const href = `/api/year/eval/discussion/download?year=${this.year}&type=${value}`
          window.open(href, '_blank')
        } catch (error) {
          const msg = error.errorMessage || error.message || '网络错误'
          message.error(msg)
        }
      }
    },
    // 点击按钮查看OKR详情
    handleClickOKRView(id) {
      if (!id) {
        return
      }

      const { href } = this.$router.resolve({
        name: 'OKRDetail',
        params: { okrId: id },
      })
      window.open(href, '_blank')
    },
    // 上传部门考评合议
    async uploadFile(info) {
      this.showDPModal = true
      this.stepDPModal = 'loading'
      if (info.file.status === 'done') {
        const result = info.file.response
        // eslint-disable-next-line
        console.log('上传部门考评合议', result)
        if (result.status) {
          this.stepDPModal = 'success'
          // 上传成功, 3秒倒计时, 刷新数据列表
          const TIME_COUNT = 3
          this.CountDown = TIME_COUNT
          this.timer = setInterval(() => {
            if (this.CountDown > 1 && this.CountDown <= TIME_COUNT) {
              this.CountDown--
            } else {
              clearInterval(this.timer)
              this.timer = null
              this.showDPModal = false
              this.fetchDPList()
            }
          }, 1000)
        } else {
          this.stepDPModal = 'fail'
          this.messageDP = result.message
        }
      } else if (info.file.status === 'error') {
        // eslint-disable-next-line
        console.log('网络错误')
        this.stepDPModal = 'fail'
        this.messageDP = '网络错误'
      }
    },
    // 获取部门考评列表数据
    async fetchDPList() {
      if (this.quarter !== 0) {
        // 获取季度部门考评列表数据
        try {
          this.isDPLoading = true
          const { maxPageIndex, okrScheduleList, isUploading } = await this.$api.okr.getDeptEvaList({
            year: this.year,
            quarter: this.quarter,
          })
          // eslint-disable-next-line
        console.log(maxPageIndex, okrScheduleList)
          let sum = 0
          const temBUArr = []
          const temBossArr = []
          okrScheduleList.forEach(i => {
          // 收集没有业绩目标的数量
            if (!i.okrId) {
              sum = sum + 1
            }
            // 收集BU名字的集合
            if (i.userDept) {
              temBUArr.push(i.userDept)
            }
            // 收集直属上司名字的集合
            if (i.bossName) {
              temBossArr.push(i.bossName)
            }
          })
          this.dpBUFilter = []
          const newBUArr = [...new Set(temBUArr)] // ES6的新语法 数组去重
          newBUArr.forEach(i => {
            this.dpBUFilter.push(
              { text: i, value: i }
            )
          })
          this.dpBossFilter = []
          const newBpssArr = [...new Set(temBossArr)] // ES6的新语法 数组去重
          newBpssArr.forEach(i => {
            this.dpBossFilter.push(
              { text: i, value: i }
            )
          })
          // eslint-disable-next-line
        console.log('this.dpBossFilter', this.dpBossFilter)

          this.totalNoOKR = sum
          this.canUpload = isUploading
          this.$set(this, 'okrDPList', okrScheduleList)
          this.totalAll = maxPageIndex

          const pagination = { ...this.paginationDP }
          // 重置列表回到第一页
          pagination.current = 1
          this.paginationDP = pagination
        } catch (error) {
          const msg = error.errorMessage || error.message || '网络错误'
          message.error(msg)
        } finally {
          this.isDPLoading = false
        }
      } else {
        // 获取年度部门考评列表数据
        try {
          this.isDPLoading = true
          const result = await this.$api.okr.getDeptListInYear({ year: this.year })
          // eslint-disable-next-line
          console.log('年度部门考评列表', result)
          const temBUArr = []
          const temBossArr = []
          const { yearEvalDepartListBo } = result
          yearEvalDepartListBo.forEach(i => {
            // 收集BU名字的集合
            if (i.bu) {
              temBUArr.push(i.bu)
            }
            // 收集直属上司名字的集合
            if (i.directUser) {
              temBossArr.push(i.directUser)
            }
          })
          this.dpBUFilter = []
          const newBUArr = [...new Set(temBUArr)] // ES6的新语法 数组去重
          newBUArr.forEach(i => {
            this.dpBUFilter.push(
              { text: i, value: i }
            )
          })
          this.dpBossFilter = []
          const newBpssArr = [...new Set(temBossArr)] // ES6的新语法 数组去重
          newBpssArr.forEach(i => {
            this.dpBossFilter.push(
              { text: i, value: i }
            )
          })
          this.canUpload = result.isUploading
          this.$set(this, 'okrDPList', yearEvalDepartListBo)
          this.totalAll = yearEvalDepartListBo.length

          const pagination = { ...this.paginationDP }
          pagination.current = 1
          this.paginationDP = pagination
        } catch (error) {
          const msg = error.errorMessage || error.message || '网络错误'
          message.error(msg)
        } finally {
          this.isDPLoading = false
        }
      }
    },
    // 部门考评列表点击换页
    handleDPChange(pagination) {
      const pager = { ...this.paginationDP }
      pager.current = pagination.current
      pager.pageSize = pagination.pageSize
      this.paginationDP = pager
    },
    // 上传合议关闭弹窗事件
    hideDPModal() {
      this.showDPModal = false
    },
    // 切换tab标签，数据更新
    handleTabChange(key) {
      // eslint-disable-next-line
        console.log('tab change',key)
      this.activeTab = key
    },
    // 根据切换tab标签，获取数据
    getDataofTab() {
      if (this.activeTab === '1') {
        this.okrDEList = []
        // 获取下级考评列表
        this.fetchDEList()
      } else if (this.activeTab === '2') {
        this.okrDPList = []
        // 获取部门考评列表
        this.fetchDPList()
      } else if (this.activeTab === '3') {
        // 获取下载按钮列表
        this.fetchDLBtn()
      }
    },
    // 获取下载按钮列表
    async fetchDLBtn() {
      try {
        const result = await this.$api.okr.getDownloadAuth()
        // eslint-disable-next-line
        console.log('download', result)
        this.$set(this, 'dlBtnList', result)
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      }
    },
    // 数据列表筛选函数
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm()
      this.searchText = selectedKeys[0]
      this.searchedColumn = dataIndex
    },
    // 数据列表重置函数
    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
    // 点击按钮编辑面谈纪要
    handleEditInterView(record) {
      if (this.quarter !== 0) {
        if (!record.id) {
          return
        }
        // 去编辑季度面谈纪要
        const { href } = this.$router.resolve({
          name: 'EditInterView',
          params: { okrId: record.id },
        })
        window.open(href, '_blank')
      } else {
        // 去编辑年度面谈纪要
        const { href } = this.$router.resolve({
          name: 'EditYearInterView',
          params: { user: record.userId, year: this.year },
        })
        window.open(href, '_blank')
      }
    },
    // 年度考评-不考评--不需要
    // handleSubmitNotYearDE(record) {
    // },
    // 年度考评-考评
    handleEditYearDE(record) {
      const { href } = this.$router.resolve({
        name: 'EditYearDireEvaluation',
        params: { user: record.userId, year: this.year },
      })
      window.open(href, '_blank')
    },
    handleClickYearDE(record) {
      const { href } = this.$router.resolve({
        name: 'YearDireEvaluationDetail',
        params: { user: record.userId, year: this.year },
      })
      window.open(href, '_blank')
    },
  },
}
</script>

<style lang="less">
@import '~@assets/style/variables.less';
.list-tab{height: 48px; line-height: 48px; font-size: @large;font-weight: 600; border-bottom: 1px solid #DDD;}
.tabLink,.tabCurrent{display: inline-flex; align-items: center;}
.tabLink{color:#444;
&:hover{color:@blue;}}
.tabCurrent{position: relative; margin-left: 18px;
&::before{content: ''; position: absolute; left: 0; bottom: 0; display: block; width: 100%; height: 4px; background: @blue;}}
.container{display: flex; padding: 40px 0;}
.sideBar{width:200px; margin-right: 16px; padding: 24px 0; background-color: @white; border-radius: 4px;}
.ant-menu-inline{border-right: none;}
.ant-menu-submenu-title{font-weight: bold;}
.rightBox{flex: 1; width:664px; }
.ant-tabs-bar{margin-bottom: 0; border-bottom: none;}
.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab{margin-right: 8px;transition:none;}
.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active{border:none; padding-bottom: 0; font-weight: 500;}
.downloadBox{padding:24px 16px; font-size: 0; text-align: right; background-color: @white; border-radius: 0 4px 4px 4px;
button + button{margin-left: 24px;}
}
.primaryBtn{background: #005EFE;
&:hover, &:active, &:focus{background: @blue;}
}
.listBar{position: absolute; top:0; left:0; right:0; display:flex;  flex-direction: row; align-items: center; justify-content: space-between; padding:24px 16px;}
.listBox{ position: relative; padding-top:80px; background-color: @white; border-radius: 0 4px 4px 4px;}
.list-loading, .list-empty{display: flex; flex-direction: column; justify-content: center; align-items: center; min-height: 234px; background-color: @white;
> img{margin-bottom: 24px;}}
.list-loading{padding: 80px;
> img{width: 160px; height: 160px;}}
.list-empty{height: 100%; color: #888;
> img{width: 79px; height: 108px;}}
.gray{color:#bbb;}
.noWrap{white-space: nowrap; font-size: 0;
&>span{font-size: 13px;}}
.tdflex{display:flex;  flex-direction: row; align-items: center;}
.tdflex2{display:flex;  flex-direction: column;}
.tdTag1{border-radius: 2px; background-color: #eee; font-size: 12px;padding: 2px 4px; color:#666; transform: scale(.8);}
.tdTag2{color:#FF3000; font-size: 12px; transform: scale(.9); padding-left: 4px;}
.tdTag3{display:inline-block; color:#bbb;font-size: 12px;transform: scale(.8);}
.linkBtn{display: inline-block; }
.linkBtn+.linkBtn,.linkBtn+button{margin-left: 8px;}

// .listTable下覆盖antd table默认样式，按设计稿渲染数据列表
.listTable .ant-table-thead > tr > th,.listTable .ant-table-tbody > tr > td { height: 40px; padding: 0 16px;}
.listTable .ant-table-thead > tr > th,.listTable .ant-table-tbody > tr > td{white-space: nowrap;}
.listTable th.column-operate,td.column-operate { padding-right: 16px; text-align: right!important;}
.listTable .ant-table-thead > tr > th:first-child, .ant-table-tbody > tr > td:first-child { padding-left: 16px!important;}
.listTable .ant-table-thead > tr > th:last-child, .ant-table-tbody > tr > td:last-child {padding-right: 16px!important;}
.listTable .ant-table-thead > tr:first-child > th:first-child { border-top-left-radius: 0;}
.listTable .ant-table-thead > tr:first-child > th:last-child { border-top-right-radius: 0;}
.ant-table,.table-btn{font-size: 13px;}
.listTable .ant-table-tbody > tr:last-child > td { border-bottom: 1px solid #e8e8e8;}
.listTable .ant-table-pagination.ant-pagination{margin: 28px 16px 28px 0;}
.listTable .ant-pagination-options-size-changer.ant-select{margin-right: 0;}
.listTable .ant-pagination-options-quick-jumper{margin-left: 16px;}
.listTable .ant-table-body{overflow-x: auto!important;}
/* 上传弹框样式更新 */
.outer{text-align: center; height: 200px;
&>div{display:flex; align-items: center; width:100%;height: 200px; flex-direction: column; justify-content: center;}}
.uploadIco{width:66px; margin-top: 20 px; margin-bottom: 20px;}
.uploading{position: absolute; top:50%; left:50%; margin:-26px 0 0 -26px; font-size:52px; color: #777;}
.uploadT6{font-size:14px; margin-bottom: 20px;}
.sucessTips{color:#999;}
.overTab .ant-tabs{overflow: inherit;}
.inlineFlex{display: flex;flex-direction: row;justify-content: space-between;}
/* 覆盖antd筛选样式 */
.newSearchStyle .ant-table-thead > tr > th .ant-table-filter-icon.anticon-search{height:28px; color:#fff!important; background-color: @blue!important; border-radius: 50%; top:50%; margin-top: -14px;}

.stateNo{color:#999;}
.stateNo::before,.stateIng::before,.stateOk::before{content: ""; display:inline-block; width:8px; height: 8px; margin-right: 6px; border-radius: 50%;}
.stateNo::before{background-color: #B5B9BF; }
.stateIng::before{background-color: #F5222D; }
.stateOk::before{background-color: #52C41A; }
</style>
